import { formatDate } from "@/utils/formatDate";

/**
 * Treść monitu o terminie przyjęcia zamówienia (backend:
 * apps.services.order_notifications.notify_order_acceptance_warning). Numer zamówienia jest
 * tytułem wiersza; tu reszta: podwykonawca, przedsięwzięcie, data wysłania, termin.
 * Po terminie zamówienie trafia do dyrekcji jako długo oczekujące — nikt go nie anuluje sam.
 */
export interface AcceptanceNotificationExtra {
  contractor?: string;
  project?: string;
  sent_date?: string;
  deadline?: string;
  /** Od kiedy zamówienie będzie „długo oczekujące”. */
  overdue_on?: string;
  /** Monity sprzed 22.10.2026 (automat jeszcze anulował) niosły tę datę zamiast overdue_on. */
  cancel_on?: string;
}

/** „Podwykonawca: X · Przedsięwzięcie: Y · wysłane 21.10.2026”. */
export function acceptanceContextLine(extra: AcceptanceNotificationExtra): string {
  const parts: string[] = [];
  if (extra.contractor) parts.push(`Podwykonawca: ${extra.contractor}`);
  if (extra.project) parts.push(`Przedsięwzięcie: ${extra.project}`);
  if (extra.sent_date) parts.push(`wysłane ${formatDate(extra.sent_date)}`);
  return parts.join(" · ");
}

/** Monit: „Termin przyjęcia mija 26.10.2026 — bez przyjęcia od 27.10.2026 zamówienie trafi do dyrekcji jako długo oczekujące”. */
export function acceptanceWarningLine(extra: AcceptanceNotificationExtra): string {
  const head = `Termin przyjęcia mija ${extra.deadline ? formatDate(extra.deadline) : ""}`.trim();
  const overdueOn = extra.overdue_on ?? extra.cancel_on;
  const next = overdueOn
    ? ` — bez przyjęcia od ${formatDate(overdueOn)} zamówienie trafi do dyrekcji jako długo oczekujące`
    : "";
  return `${head}${next}. Zadzwoń do podwykonawcy albo przedłuż termin.`;
}
